import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { User } from '@ps/auth-data-access';

import { FeatureAccessEntitlementsResponseDto } from './dtos/entitlement.dto';
import { EntitlementMapper } from './mappers/entitlement.mapper';
import { FeatureEntitlement } from '../models/entitlement.model';

const ACCESS_LEVEL_NONE = 'none';

function featureAccessQueryParams(user: User): HttpParams {
  return new HttpParams()
    .set('buyer', user.buyerAccessLevel || ACCESS_LEVEL_NONE)
    .set('operator', user.operatorAccessLevel || ACCESS_LEVEL_NONE)
    .set('supplier', user.supplierAccessLevel || ACCESS_LEVEL_NONE);
}

@Injectable({ providedIn: 'root' })
export class EntitlementApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _mapper = new EntitlementMapper();

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  public getEntitlements(user: User): Observable<FeatureEntitlement[]> {
    const params = featureAccessQueryParams(user);
    return this._http
      .get<FeatureAccessEntitlementsResponseDto>(
        `${this._baseUrl}/feature/access`,
        { params },
      )
      .pipe(map((response) => this._mapper.fromResponse(response)));
  }
}
